export default "__VITE_ASSET__De6g1ctL__"